// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, } from '@mui/material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import { BoxGridColumnsContainer, BoxGridColumnsFullWidth } from '../../Common/BoxGridColumns';
import BoxImage from '../../Common/BoxImage';
import {ContentTitle,MultipleRows } from '../../Common/TypographyTYH';

const BoxFlagGuards = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component BoxFlagGuards Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const images = [
        'https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FG01.jpg',
        'https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FG02.jpg',
        'https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FG03.jpg',
        'https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FG04.jpg',
        'https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FG05.jpg',
        'https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FG06.jpg',
        'https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FG07.jpg',
        'https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FG08.jpg',
    ];

    // TODO: Define event

    // TODO: Return component
    return (
        <BoxGridColumnsContainer>
            <BoxGridColumnsFullWidth>
                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                    <BoxImage
                        src="https://www.pohtyh.edu.hk/Files/StudentDevelopment/UniformedGroups/FGLogo.png"
                        sx={{ aspectRatio: '1/1', objectFit: 'contain', width: '24px', }}
                        sxSkeleton={{ aspectRatio: '1/1', width: '24px', }}
                    />
                    <ContentTitle text={Text.StudentDevelopment.UniformedGroups.FlagGuards.Title[context.language]} />
                </Box>
                <MultipleRows rows={Text.StudentDevelopment.UniformedGroups.FlagGuards.Intro[context.language]} />
            </BoxGridColumnsFullWidth>
            {
                images.map((image, i) => (<BoxImage key={i} src={image} />))
            }
        </BoxGridColumnsContainer>
    );
}

export default BoxFlagGuards;